import "flickity-imagesloaded";
import Flickity from "flickity";
import "flickity/css/flickity.css";

const ARROW_SHAPE =
  "M32.702 57.493L60.829 85.62 48.749 97.7 0 48.95 48.75.203l12.079 12.08-28.127 28.127H100v17.084z";

const carousels = document.querySelectorAll(".js-carousel");
const SYNCED_HEIGHT_CLASS = "has-synced-height";

const getElementBottom = (element) => element.getBoundingClientRect().bottom;

const getSlideContentHeight = (slide) => {
  const slideTop = slide.getBoundingClientRect().top;
  const contentElements = slide.querySelectorAll(".card, .card > *");
  const contentBottom = [...contentElements].reduce(
    (bottom, element) => Math.max(bottom, getElementBottom(element)),
    getElementBottom(slide)
  );

  return Math.max(
    slide.offsetHeight,
    slide.scrollHeight,
    Math.ceil(contentBottom - slideTop)
  );
};

const getTallestSlideHeight = (carousel) =>
  [...carousel.querySelectorAll(".l-carousel__slide")].reduce(
    (height, slide) => Math.max(height, getSlideContentHeight(slide)),
    0
  );

const syncCarouselHeight = (carousel, flkty) => {
  carousel.classList.remove(SYNCED_HEIGHT_CLASS);
  carousel.style.removeProperty("--section-carousel-slide-height");

  if (flkty.viewport) {
    flkty.viewport.style.height = "";
  }

  flkty.reloadCells();
  flkty.resize();

  const tallestSlideHeight = getTallestSlideHeight(carousel);

  if (!tallestSlideHeight) {
    updateCarouselScrollState(carousel, flkty);
    return;
  }

  const height = `${tallestSlideHeight}px`;

  carousel.style.setProperty("--section-carousel-slide-height", height);
  carousel.classList.add(SYNCED_HEIGHT_CLASS);

  if (flkty.viewport) {
    flkty.viewport.style.height = height;
  }
};

const requestCarouselHeightSync = (carousel, flkty) => {
  if (carousel.isSyncingHeight) {
    return;
  }

  carousel.isSyncingHeight = true;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      syncCarouselHeight(carousel, flkty);
      updateCarouselScrollState(carousel, flkty);
      carousel.isSyncingHeight = false;
    });
  });
};

const updateCarouselScrollState = (carousel, flkty) => {
  const hasScroll = flkty.slides.length > 1;

  carousel.classList.toggle("has-no-scroll", !hasScroll);
};

const onCarouselLayout = (carousel, flkty) => {
  requestCarouselHeightSync(carousel, flkty);
};

const initSectionCarousel = (carousel) => {
  const slideCount = carousel.querySelectorAll(".l-carousel__slide").length;

  if (slideCount < 2) {
    carousel.classList.add("is-static");
    return;
  }

  const flkty = new Flickity(carousel, {
    cellAlign: "left",
    contain: true,
    groupCells: true,
    imagesLoaded: true,
    percentPosition: false,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: false,
    draggable: true,
    arrowShape: ARROW_SHAPE,
  });

  flkty.on("ready", () => onCarouselLayout(carousel, flkty));
  flkty.on("settle", () => onCarouselLayout(carousel, flkty));
  flkty.on("resize", () => onCarouselLayout(carousel, flkty));
  flkty.on("imagesLoaded", () => onCarouselLayout(carousel, flkty));

  carousel.querySelectorAll("img").forEach((image) => {
    image.addEventListener("load", () => onCarouselLayout(carousel, flkty));

    if (image.complete) {
      onCarouselLayout(carousel, flkty);
    }
  });

  onCarouselLayout(carousel, flkty);
  window.addEventListener("load", () => onCarouselLayout(carousel, flkty));
  window.addEventListener("resize", () => onCarouselLayout(carousel, flkty));
};

[...carousels].forEach((carousel) => initSectionCarousel(carousel));
